import { Component } from 'react';

import styles from './ComplionToolbar.scss';

class ComplionToolbarDivider extends Component {
    render() {
        return (
            <span className={styles.complionToolbarDivider}></span>
        );
    }
}

export default ComplionToolbarDivider;
